import React, { Component } from 'react';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';

class StaffPaperPendencyDayInterruptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      staff_paper_day_id: this.props.staff_paper_day_id,
      id: this.props.interruption.id,
      start: this.props.interruption.start_str,
      finish: this.props.interruption.finish_str,
      total: this.props.interruption.total,
    };

    //bind específico
    this.edit = this.edit.bind(this);
    this.delete = this.delete.bind(this);
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        id: newProps.interruption.id,
        staff_paper_day_id: newProps.staff_paper_day_id,
        start: newProps.interruption.start_str,
        finish: newProps.interruption.finish_str,
        total: newProps.interruption.total,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  edit() {
    var datasave = {
      staff_paper_day_id: this.state.staff_paper_day_id,
      id: this.state.id,
      start: this.state.start,
      finish: this.state.finish,
    };
    this.props.editInterruptions(datasave);
  }

  delete(id) {
    this.props.deleteInterruptions(id);
  }

  render() {
    var self = this;
    return (
        <tr>
            <td>{this.state.start}</td>
            <td>{this.state.finish}</td>
            <td style={{textAlign: 'center'}}>{this.state.total}</td>            
        </tr>
    );
  }
}

export default StaffPaperPendencyDayInterruptions;



// WEBPACK FOOTER //
// ./src/Components/StaffPapers/Elements/StaffPaperPendencyDayInterruptions.js